import type { FaireProductEntity } from "../../entity_types/product";

export const p_8xwdtsrxhr: FaireProductEntity = {
  token: "p_8xwdtsrxhr",
  type: "product",
  name: "STRIPED CONTRAST SET",
  brandToken: "b_1jsnz1e7d6",
  brandName: "Blu Pepper",
  imageUrl:
    "https://cdn.faire.com/fastly/b55c7cc28aac02c60e7160c145685f4f9db5631a5b0ce166bdf0899b2bfb2995.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6ae408bd070fe0dec09c3940a1f765a157860fb8bd2ccd59c6bb2960ccc95370.jpeg",
    "https://cdn.faire.com/fastly/a39294efe5804d71910c3fcc93aa5440f7035f586ca94ebcf14c74d2c2aa27c6.jpeg",
    "https://cdn.faire.com/fastly/052437904d193dbb74ec4e01cf9479f6d73579ef45da723ac546f327351c650b.jpeg",
    "https://cdn.faire.com/fastly/72bd089f57210ac0c10ec11e66cc2b7af8c717494fcca489521aadd50586b9e2.jpeg",
    "https://cdn.faire.com/fastly/13a72fd5808ece3a07bc21c731b06c6b8ec726bdaf90b18c1e108b6a0b6fc1f3.jpeg",
    "https://cdn.faire.com/fastly/96e3155b7738e47b3cebf666b9c538088b38a1f48cad5f554821e1b10013f4c0.jpeg",
    "https://cdn.faire.com/fastly/575673892d37361a9bf8d58d456097e902bbf955e46b355af4d22de598594be8.jpeg",
    "https://cdn.faire.com/fastly/26e5377761914a7b3ef715a8f04bbbeaa352e4fd9ed777bfe3968cd563b66a5f.jpeg",
  ],
  priceDollars: 13.75,
  description:
    "- CA2220-SET\n\nTOP \n- 2 SMALL 2 MEDIUM 2 LARGE\n- ROUND NECKLINE\n- LONG SLEEVES\n- STRIPED\n\nBOTTOMS\n- 2 SMALL 2 MEDIUM 2 LARGE\n- DRAWSTRING\n- TASSEL DRAWSTRING\n- STRIPED\n- CONTRAST DETAIL\n- 85% COTTON 15% POLYESTER\n- CONTRAST: 100% COTTON",
  tags: [],
  msrpDollars: 41.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:49.326Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
